import APIService from "./API.service";
const queryString = require("query-string");

class AnalyticsSettingsService extends APIService {
  // Get Analytics Url
  generatePublicSharingToken(eventId: string = "0"): Promise<any> {
    const query = {
      eventId,
    };

    return this.call.get(
      `${this.apiUrl}/generate-token?${queryString.stringify(query)}`
    );
  }

  revokePublicSharingToken(eventId: string = "0"): Promise<any> {
    const query = {
      eventId,
    };

    return this.call.get(
      `${this.apiUrl}/revoke-token?${queryString.stringify(query)}`
    );
  }

  fetchPublicUrl(eventId: string = "0"): Promise<any> {
    const query = {
      eventId,
    };

    return this.call.get(
      `${this.apiUrl}/fetch-public-url?${queryString.stringify(query)}`
    );
  }

  fetchIframeUrl(token: string = ""): Promise<any> {
    const query = {
      token,
    };

    return this.call.get(
      `${this.apiUrl}/fetch-iframe-url?${queryString.stringify(query)}`
    );
  }
}

export default AnalyticsSettingsService;
